export default "__VITE_ASSET__awzcYrw$__"